import { faGithub, faLinkedin/*, faYoutube*/ } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaChevronCircleUp } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { Context } from "../../context";
import classes from "./Footer.module.css";

const Footer = () => {
  const parse = require("html-react-parser");
  const [data, setData] = useState([]);
  const [error, setError] = useState([]);

  const { debug, linkedin, github, lang, youtube } = useContext(Context);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className={classes.codeBorderTop}></div>
      <Container fluid={true} className={classes.Section}>
        <div className={classes.matrixOverlay}></div>
        <Container className={classes.footerContainer}>
          <Row>
            {/* Developer Info Section */}
            <Col lg="6" md={6} sm={12} className={classes.footerCol1}>
              <div className={classes.codeBlock}>
                <span className={classes.codeLine}><span className={classes.keyword}>const</span> <span className={classes.varName}>developer</span> = <span className={classes.symbol}>{'{'}</span></span>
                <div className={classes.indent}>
                  <h2 className={`${classes.Name} text-left`}>"Davide Balice"</h2>
                  <p className={classes.Description}>
                    <span className={classes.comment}>// Full stack web developer</span>
                    <br />
                    <span className={classes.prop}>site</span>: <span className={classes.string}>"davidebalice.dev v1.5.1"</span>,
                    <br />
                    <span className={classes.prop}>email</span>: <span className={classes.string}>"davide.balice@gmail.com"</span>
                  </p>
                </div>
                <span className={classes.codeLine}><span className={classes.symbol}>{'}'}</span>;</span>
              </div>
            </Col>

            {/* Links & Social Section */}
            <Col lg="6" md={6} sm={12} className={classes.footerCol2}>
              <div className={classes.terminalWindow}>
                <div className={classes.terminalHeader}>
                  <span className={classes.dotRed}></span>
                  <span className={classes.dotYellow}></span>
                  <span className={classes.dotGreen}></span>
                  <span className={classes.terminalTitle}>bash -- social</span>
                </div>
                <div className={classes.terminalBody}>
                  <div className={classes.commandRow}>
                    <span className={classes.prompt}>$</span> ls ./legal
                  </div>
                  <div className={classes.outputRow}>
                    <NavLink to="/privacy" className={classes.legalLink}>Privacy.md</NavLink>
                    <span className={classes.separator}> </span>
                    <NavLink to="/cookie" className={classes.legalLink}>Cookie.js</NavLink>
                  </div>
                  <br />

                  <div className={classes.commandRow}>
                    <span className={classes.prompt}>$</span> ./connect.sh
                  </div>
                  <div className={classes["social-container"]}>
                    <a className={classes.social} href={linkedin} target="_blank" rel="noreferrer">
                      <FontAwesomeIcon icon={faLinkedin} size="2x" />
                    </a>
                    <a className={classes.social} href={github} target="_blank" rel="noreferrer">
                      <FontAwesomeIcon icon={faGithub} size="2x" />
                    </a>
                    {/* <a className={classes.social} href={youtube} target="_blank" rel="noreferrer">
                      <FontAwesomeIcon icon={faYoutube} size="2x" />
                    </a> */}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>

      <Container fluid={true} className={`${classes.copyright} text-center`}>
        <div className={classes.gitBranch}>
          <span className={classes.branchIcon}>git:(<span className={classes.branchName}>main</span>)</span>
        </div>
        <p className={classes.copyrightlink}>&copy; {new Date().getFullYear()} Davide Balice. All rights reserved.</p>
        <div onClick={scrollToTop} className={classes.footerTop}>
          <FaChevronCircleUp /> <span className={classes.topText}>cd ..</span>
        </div>
      </Container>
    </>
  );
};

export default Footer;
